import styled, { css } from 'styled-components';

export const FeatureGridWrapper = styled.div`
  a {
    text-decoration: none !important;
  }
  text-align: center;
  padding-right: 2em;
  @media only screen and (max-width: 639px) {
    padding-right: 0em;
  }
`;

export const chevronNewLine = css`
  white-space: nowrap;
  svg {
    stroke: red;
    margin-left: 0.1em;
    height: 0.8em;
  }
`;